import { render, staticRenderFns } from "./SpaceFeatures.vue?vue&type=template&id=4a70b9b1&scoped=true"
import script from "./SpaceFeatures.vue?vue&type=script&lang=ts"
export * from "./SpaceFeatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70b9b1",
  null
  
)

export default component.exports